
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welcome/login",
      function () {
        return require("private-next-pages/welcome/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/welcome/login"])
      });
    }
  